import type { OpcaoLocalDeTrabalho } from '../catalogo-local-de-trabalho.tipos'

export type ListarOpcoesLocalRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoLocalDeTrabalho[]>

export const criarCasoDeUsoListarOpcoesLocal = (
  listarNoRepositorio: ListarOpcoesLocalRepositorio,
): ListarOpcoesLocalRepositorio => async (sinal) => listarNoRepositorio(sinal)
